import { Box, Flex, Space } from '@mantine/core';
import { translate } from '@shared/i18n/translate.tsx';
import { useParams } from '@tanstack/react-router';

import { ArtistInteractionContainer } from '@/features/work-interactions/containers/ArtistinteractionContainer';
import { LBBackButton } from '@/shared/modules';
import { LBLinkButton } from '@/shared/ui-kit/components';

export const ClubWorkInviteInfoPage = () => {
  const { id: clubId, workInviteId } = useParams({
    from: '/clubOwner/$id/work-invite/$workInviteId'
  });

  return (
    <>
      <Box>
        <Flex align='center' justify='space-between'>
          <LBBackButton />
          <LBLinkButton>{translate('commons.help')}</LBLinkButton>
          {/* <LBLinkButton>Помощь</LBLinkButton> */}
        </Flex>
        <Space h={16} />
      </Box>{' '}
      <ArtistInteractionContainer clubId={clubId} workItemId={workInviteId} />
    </>
  );
};
